import React from 'react';

import { getErrorData } from 'common/constants/get-error-data';
import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import { Tooltip } from 'core/components/tooltip';
import Block from 'core/assets/svg/ic-block.svg';
import useStyles from './blocks.styles';

const processWhy = (why) => {
  if (why?.toLowerCase().includes('validation error of type fieldundefined')) {
    // schema mismatch between frontend and backend
    return 'There was an error submitting this request. Please escalate to support if this error persists.';
  }
  return why;
};

export const Blocks = () => {
  const classes = useStyles();
  const { isAgency, isInternalAgent, isInternalSales } = useSession();
  const {
    offer: store,
    quote: { getBlocks }
  } = useStore();

  const blocks = getBlocks();

  return (
    <div className={classes.container}>
      {blocks.map((error) => {
        const blockData = getErrorData({
          error,
          isAgency,
          state: store.state,
          errorType: 'BLOCK'
        });

        return (
          <div className={classes.block} key={`block-${blockData.code}`}>
            {/* top row */}
            <div className={classes.iconRow}>
              {/* left content */}
              <div className={classes.row}>
                <img src={Block} alt="block" />
                {/* stacked block details */}
                <div className={classes.titleColumn}>
                  <div className={classes.code}>BLOCK: {blockData.code || 'Unknown Block'}</div>
                  <div className={classes.title}>{blockData?.title || 'Unknown Block'}</div>
                </div>
              </div>

              {/* right content */}
              {isInternalAgent && isInternalSales && blockData?.branchPlusEligible && (
                <div className={classes.branchPlusEligible}>
                  Branch Plus eligible
                  <Tooltip
                    text="Although we may not be able to write this coverage due to this reason, our partnered providers typically do."
                    placement="top"
                  />
                </div>
              )}
            </div>

            {/* subtitle row */}
            <div className={classes.subtitle}>{blockData?.subtitle || blockData?.message}</div>

            {/* "why" section for unknown errors and 360Value errors (code 4001) which will show the raw error message */}
            {(!blockData.code || blockData.code === 4001) && blockData?.why && (
              <div className={classes.subtitle}>{processWhy(blockData?.why)}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Blocks;
